<template>
  <div class="row pl-3">
    <span class="align-self-center">{{ firstLabel }}</span>

    <input v-if="type == 'number'" :disabled="disabled" class="form-control mx-2 col-5" :type="type" v-model="inputValue" min="1" :required="inputRequired" />
    <input v-else :disabled="disabled" class="form-control mx-2 col-5" :type="type" v-model="inputValue" :required="inputRequired" />
    <span class="align-self-center">{{ secondLabel }}</span>
  </div>
</template>

<script>
export default {
  props: {
    firstLabel: {
      type: String,
      default: "" 
    },
    secondLabel: {
      type: String,
      default: "" 
    },
    value: {
      type: [String, Number],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputRequired: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text"
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  watch: {
    inputValue(newVal) {
      this.$emit('update:value', newVal);
    },
    value(newVal) {
      this.inputValue = newVal;
    },
  },
}

</script>
